import axios from "axios";
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import Footer from "../common/Footer";
import HeaderMyAccount from "../common/HeaderMyAccount";
import { DayPicker } from "react-day-picker";
import { format } from "date-fns";
import { FaRegCalendarAlt } from "react-icons/fa";
import "react-day-picker/dist/style.css";
import "../../styles/calendar.scss";
import { TZDate } from "@date-fns/tz";

function InsertUser() {
  const [title, setTitle] = useState("Mr.");
  const [firstName, setFname] = useState("");
  const [lastName, setLname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setCPassword] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [pwError, setPwError] = useState(false);
  const [confirmPasswordError, setCPwError] = useState(false);
  const [role, setRole] = useState("Admin");
  const [userStatus, setUserStatus] = useState("Active");
  const [sessionValidUntil, setSessionValidUntil] = useState("");
  const [open, setOpen] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(true);
  const [disabled, setDisabled] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const pickerRef = useRef(null);
  
    // Today
    const timeZone = "Australia/Sydney";
  
    // Current date in Pacific Time
    const now = new TZDate(Date.now(), timeZone);
  
    // Tomorrow (00:00)
    const tomorrow = new TZDate(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + 1,
      timeZone
    );

    useEffect(() => {
    function handleClickOutside(event) {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  let navigate = useNavigate();
  const { user } = useAuth();
  function addUser(e) {
    e.preventDefault();
    setDisabled(true);
    let registerURL = process.env.REACT_APP_API_URL + "/create-user";
    let payload = {
      title,
      firstName,
      lastName,
      email,
      password,
      role,
      confirmPassword,
      userStatus,
      sessionValidUntil: sessionValidUntil ? format(sessionValidUntil, "yyyy-MM-dd") : "",
    };
    axios
      .post(registerURL, payload, {
        headers: { Authorization: "Bearer " + user.jwtToken },
      })
      .then((res) => {
        if (res.data === "409") {
          setDisabled(true);
          setErrorMessage("Email is already registered");
          setTimeout(() => {
            setDisabled(false);
            setErrorMessage("");
          }, 1000);
        } else {
          setDisabled(false);
          navigate("/users");
        }
      })
      .catch((err) => {
        console.log(err, "err");
      });
  }

  return (
    <div className="w-100 h-100 bg-green5">
      <HeaderMyAccount />
      <main className="main-section mx-4 rounded-top-3 overflow-y-scroll bg-white custom-scroller userList">
        <span className="fs-4 mt-5 fw-bold lh-sm d-flex justify-content-center">
          Add New User
        </span>
        <div className="d-flex justify-content-center">
          <div className="ps-5 pt-5 w-75">
            <form className="row g-3 bg-green4 rounded p-3" onSubmit={addUser}>
              <div className="col-6">
                <label
                  htmlFor="validationCustom00"
                  className="form-label fw-bold"
                >
                  Title
                </label>
                <select
                  className="form-select"
                  id="validationCustom00"
                  name="title"
                  required
                  onChange={(e) => {
                    setTitle(e.target.value);
                  }}
                  defaultValue="Mr."
                >
                  <option value="Mr.">Mr.</option>
                  <option value="Mrs.">Mrs.</option>
                  <option value="Miss">Miss</option>
                </select>
                <div className="invalid-feedback">
                  Please select a valid title.
                </div>
              </div>
              <div className="col-6">
                <label
                  htmlFor="validationCustom01"
                  className="form-label fw-bold"
                >
                  First name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="validationCustom01"
                  name="fname"
                  required
                  onChange={(e) => {
                    setFname(e.target.value);
                  }}
                />
                <div className="valid-feedback">Looks good!</div>
              </div>
              <div className="col-6">
                <label
                  htmlFor="validationCustom02"
                  className="form-label fw-bold"
                >
                  Last name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="validationCustom02"
                  name="lname"
                  required
                  onChange={(e) => {
                    setLname(e.target.value);
                  }}
                />
                <div className="valid-feedback">Looks good!</div>
              </div>
              <div className="col-6">
                <label htmlFor="inputEmail" className="form-label fw-bold">
                  Email
                </label>
                <div className="input-group has-validation">
                  <input
                    type="email"
                    className="form-control"
                    id="inputEmail"
                    name="email"
                    autoComplete="off"
                    required
                    onChange={(e) => {
                      setEmailError(false);
                      setEmail(e.target.value);
                    }}
                  />
                  <div className="invalid-feedback">Please choose a email.</div>
                </div>
              </div>
              <div className="col-6">
                <label htmlFor="inputPassword" className="form-label fw-bold">
                  Password
                </label>
                <div className="input-group has-validation">
                  <input
                    type="password"
                    className="form-control"
                    id="inputPassword"
                    autoComplete="new-password"
                    name="password"
                    required
                    onChange={(e) => {
                      setPwError(false);
                      setPassword(e.target.value);
                    }}
                  />
                  <div className="invalid-feedback">
                    Please choose a password.
                  </div>
                </div>
              </div>
              <div className="col-6">
                <label htmlFor="inputCPassword" className="form-label fw-bold">
                  Confirm Password
                </label>
                <div className="input-group has-validation">
                  <input
                    type="password"
                    className="form-control"
                    id="inputCPassword"
                    autoComplete="new-password"
                    name="confirmpassword"
                    required
                    onChange={(e) => {
                      setPwError(false);
                      setCPassword(e.target.value);
                      if (password != e.target.value) {
                        setCPwError(true);
                        setDisabled(true);
                      } else {
                        setCPwError(false);
                        setDisabled(false);
                      }
                    }}
                  />
                  <div className="invalid-feedback">
                    Please choose a confimr password.
                  </div>
                </div>
                {confirmPasswordError && (
                  <div className="text-danger text-center">
                    {" "}
                    Confirm password is not matched{" "}
                  </div>
                )}
              </div>
              <div className="col-6">
                <label
                  htmlFor="validationCustom04"
                  className="form-label fw-bold"
                >
                  Role
                </label>
                <div className="position-relative">
                  <select
                    className="form-select"
                    id="validationCustom04"
                    name="role"
                    required
                    onChange={(e) => {
                      setRole(e.target.value);
                    }}
                    defaultValue="Admin"
                  >
                    <option value="Admin">Admin</option>
                    <option value="Student">Student</option>
                  </select>
                  <div className="invalid-feedback">
                    Please select a valid role.
                  </div>
                </div>
              </div>
              <div className="col-6">
                <label htmlFor="validationCustom04" className="form-label">
                  Status
                </label>

                <select
                  className="form-select"
                  id="validationCustom04"
                  name="userStatus"
                  value={userStatus}
                  onChange={(e) => setUserStatus(e.target.value)}
                  required
                >
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </select>

                <div className="invalid-feedback">
                  Please select a valid status.
                </div>
              </div>
            {role === "Student" && (
              <>
              <div className="col-6">
                <label className="form-label fw-semibold mb-2">
                  Session Valid Until
                </label>

                <div className="date-picker-wrapper" ref={pickerRef}>
                  <div
                    className={`date-input ${open ? "active" : ""}`}
                    onClick={() => setOpen(!open)}
                  >
                    <span className={sessionValidUntil ? "selected-date" : ""}>
                      {sessionValidUntil
                        ? format(sessionValidUntil, "dd MMM yyyy")
                        : "Select session expiry"}
                    </span>

                    <FaRegCalendarAlt className="calendar-icon" />
                  </div>

                  {open && (
                    <div className="calendar-popup">
                      <DayPicker
                        mode="single"
                        timeZone={timeZone}
                        selected={sessionValidUntil}
                        onSelect={(date) => {
                          setSessionValidUntil(date);
                          setOpen(false);
                        }}
                        disabled={{
                          before: tomorrow,
                        }}
                        showOutsideDays
                        fixedWeeks
                      />

                      <div className="calendar-footer">
                        <button
                          type="button"
                          className="btn-clear"
                          onClick={() => {
                            setSessionValidUntil(undefined);
                            setOpen(false);
                          }}
                        >
                          Clear
                        </button>

                        <button
                          type="button"
                          className="btn-today"
                          onClick={() => {
                            setSessionValidUntil(new Date());
                            setOpen(false);
                          }}
                        >
                          Today
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-6"></div>
              </>
            )}
              {errorMessage && (
                <div className="text-danger text-center">{errorMessage}</div>
              )}
              <div className="col-12">
                <button
                  className="btn btn-secondary"
                  type="submit"
                  disabled={disabled}
                >
                  {disabled ? "Saving..." : "Save"}
                </button>
                &nbsp;
                <Link className="btn btn-primary" to="/users">
                  Close
                </Link>
              </div>
            </form>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
export default InsertUser;
